export const firenaseCodes = {
    "auth/user-not-found": "Não há registro de usuário correspondente a este e-mail. Verifique seu e-mail e tente novamente.",
    "auth/wrong-password": "A senha é inválida ou o usuário não possui uma senha.",
    "auth/too-many-requests": "O acesso a esta conta foi temporariamente desativado devido a muitas tentativas de login malsucedidas. Você pode restaurá-la imediatamente redefinindo sua senha ou pode tentar novamente mais tarde."
}


export const errorUserQuery = {
    cpf: "O CPF digitado não foi encontrado em nosso sistema. Tente novamente.",
    cnpj: "O CNPJ digitado não foi encontrado em nosso sistema. Tente novamente."
}

export const messageDefault = {
    default: "Verifique seu e-mail e senha e tente novamente."
}